import { IAppState } from '../../store';

export const selectRealtyUserId = (state: IAppState) =>
  state.user.isAuthenticated ? state.user.realtyUserId : undefined;
